/* The contents of this file are generated automatically during the build process of this component.
* If you need to make changes on these styles, go to the .scss files of this repository.
* Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML =
`<custom-style>
  <style>
    html {
      --message-grey: #78899E;
      --inactive-grey: #A1AFC0;
      --detail-grey: #D0D7DE;
      --chrome-grey: #ECF1F4;
      --active-grey: #8294AA;
      --border-grey: #EEEEEE;

      --good-to-go-green: #43A85F;
      --alert-orange: #DD3700;
      --focus-blue: #79BBDE;

      --background-component: #EBF6FC;

      --primary-active: #00233C;
      --primary-action: #0079BC;
      --primary-hover: #006096;
      --primary-disabled: #B7E4F7;

      --primary-active-contrast: #00233C;
      --active-grey-contrast: #607682;

      --foreground-header: #253B56;
      --foreground-body: #253B56;

      --transactional-action: #61941B;
      --transactional-hover: #58831B;
      --transactional-active: #33490F;
      --transactional-disabled: #D6E5BA;

      --eec-title: #1F3451;
      --eec-subtitle: #66788E;

      --border-gray: #DFDFDF;

      --dlp-primary-active: #253050;
      --dlp-primary-action: #0046e4;
      --dlp-primary-hover: #0033cc;
      --dlp-message-grey: #6a798a;
      --dlp-detail-grey: #c3cad3;
      --dlp-good-to-go-green: #008820;
      --dlp-alert-orange: #dd1f00;
    }
  </style>
</custom-style>`;
const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
  <style>
    .message-grey {
      color: var(--message-grey);
    }
    .inactive-grey {
      color: var(--inactive-grey);
    }
    .detail-grey {
      color: var(--detail-grey);
    }
    .chrome-grey {
      color: var(--chrome-grey);
    }
    .alert-orange {
      color: var(--alert-orange);
    }
    .active-grey {
      color: var(--active-grey);
    }
    .background-message-grey {
      background-color: var(--message-grey);
    }
    .background-inactive-grey {
      background-color: var(--inactive-grey);
    }
    .background-detail-grey {
      background-color: var(--detail-grey);
    }
    .background-chrome-grey {
      background-color: var(--chrome-grey);
    }
    .background-good-to-go-green {
      background-color: var(--good-to-go-green);
    }
    .background-alert-orange {
      background-color: var(--alert-orange);
    }
    .good-to-go-green {
      color: var(--good-to-go-green);
    }
    .foreground-header {
      color: var(--foreground-header);
    }
    .foreground-body {
      color: var(--foreground-body);
    }
    .primary-active {
      color: var(--primary-active);
    }
    .primary-action {
      color: var(--primary-action);
    }
    .primary-hover {
      color: var(--primary-hover);
    }
    .primary-disabled {
      color: var(--primary-disabled);
    }
    .transactional-action {
      color: var(--transactional-action);
    }
    .transactional-hover {
      color: var(--transactional-hover);
    }
    .transactional-active {
      color: var(--transactional-active);
    }
    .transactional-disabled {
      color: var(--transactional-disabled);
    }
    .background-foreground-header {
      background-color: var(--foreground-header);
    }
    .background-foreground-body {
      background-color: var(--foreground-body);
    }
    .background-component {
      background-color: var(--background-component);
    }
    .background-primary-active {
      background-color: var(--primary-active);
    }
    .background-primary-action {
      background-color: var(--primary-action);
    }
    .background-primary-hover {
      background-color: var(--primary-hover);
    }
    .background-primary-disabled {
      background-color: var(--primary-disabled);
    }
    .background-transactional-action {
      background-color: var(--transactional-action);
    }
    .background-transactional-hover {
      background-color: var(--transactional-hover);
    }
    .background-transactional-active {
      background-color: var(--transactional-active);
    }
    .background-transactional-disabled {
      background-color: var(--transactional-disabled);
    }
    .primary-active-contrast {
      color: var(--primary-active-contrast);
    }
    .background-primary-active-contrast {
      background-color: var(--primary-active-contrast);
    }
  </style>
</template>`;

styleElement.register('com-theme-color');
document.head.appendChild($_documentContainer.content);